module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/decorations/deco-blob-10-c01af949aa4cad7cb4947ecde96d51ce.svg";